import { ZfFileItem, ZfFilesUpload } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ClientPackageAppendixDocumentDto } from '../../api/generated/client';
import { CLIENT_PACKAGE_DOCUMENT_TYPE } from '../../config/constants';

interface IClientPackageAppendixFileProps {
    appendix: ClientPackageAppendixDocumentDto;
    isDisabled: boolean;
    onFileUpload?: (files: File[]) => void;
    onFileDownload?: () => void;
    onFileDelete?: () => void;
}

export const ClientPackageFileActions: FunctionComponent<IClientPackageAppendixFileProps> = ({
    appendix,
    isDisabled,
    onFileDownload,
    onFileUpload,
    onFileDelete,
}) => {
    const { t } = useTranslation();

    return (
        <div className="client-package-editor__file-actions">
            {appendix.documentUuid && appendix.filename ? (
                <ZfFileItem name={appendix.filename} onFileDownload={onFileDownload} deletable={!isDisabled} onFileDelete={onFileDelete} />
            ) : (
                <ZfFilesUpload
                    text={t('clientPackageAppendixActionUpload')}
                    size="extra-small"
                    hierarchy="secondary"
                    accept={CLIENT_PACKAGE_DOCUMENT_TYPE}
                    disabled={isDisabled}
                    onFileInputChange={(event: CustomEvent<File[]>) => onFileUpload?.(event.detail)}
                />
            )}
        </div>
    );
};
